import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './components/Home';
import About from './components/About';
import Services from './components/Services';
import Tools from './components/Tools';
import Blog from './components/Blog';
import Contact from './components/Contact';
import EmiCalculator from "./components/EmiCalculator";

// Importing new service pages
import BusinessLoans from './components/services/BusinessLoans';
import OverdraftFacilities from './components/services/OverdraftFacilities';
import GovernmentBackedSchemes from './components/services/GovernmentBackedSchemes';

function App() {
  return (
    <Router>
      <Header />
      <main>
        <Routes>
          {/* Main Pages */}
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/tools" element={<Tools />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/contact" element={<Contact />} />

          {/* Service Detail Pages */}
          <Route path="/services/business-loans" element={<BusinessLoans />} />
          <Route path="/services/overdraft-facilities" element={<OverdraftFacilities />} />
          <Route path="/services/government-backed-schemes" element={<GovernmentBackedSchemes />} />
          <Route path="/tools/loan-emi-calculator" element={<EmiCalculator />} />
        </Routes>
      </main>
      <Footer />
    </Router> 
  );
}

export default App;